import TalkableProviderHOC from './Talkable';
import TalkableDiv from './TalkableDiv';

export default TalkableProviderHOC;
export {TalkableDiv};
